import React from 'react';
import styled from 'styled-components';
import { FormattedCurrency } from 'i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function UpgradeComponent({ description, price, icon }) {
  return (
    <Root>
      <Description>
        <Icon icon={icon} />
        {description}
      </Description>
      <Price>
        +<FormattedCurrency value={price} />
      </Price>
    </Root>
  );
}

export default UpgradeComponent;

const Root = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Icon = styled(FontAwesomeIcon)``;

const Description = styled.div`
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.text.default};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${Icon} {
    margin-right: 10px;
    color: ${({ theme }) => theme.colors.buttons.grey};
  }
`;

const Price = styled.div`
  font-size: 1.2em;
  color: ${({ theme }) => theme.colors.text.default};
  font-weight: bold;
`;
